import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['dateOfBirth', 'partnerDateOfBirthDd'],
  validate (value, { dateOfBirth, partnerDateOfBirthDd, dateOfInsuranceStart }) {
    let status = true;
    let minDate = new UtcDate(dateOfBirth).min(new UtcDate(partnerDateOfBirthDd));

    if (!partnerDateOfBirthDd) minDate = new Date(dateOfBirth);
    const age = new UtcDate(dateOfInsuranceStart).differenceInYears(minDate);

    if (value < this.constants.COVER_MIN_AGE) status = false;
    if (value + age > this.constants.COVER_MAX_AGE) status = false;

    return status;
  },
  message (fieldName, { _value_ }) {
    if (_value_ < this.constants.COVER_MIN_AGE) return 'Please enter a cover term of 5 years or more. ';

    return 'Insurance providers normally only provide cover until you are 70 years old. ';
  },
};
